import Model, { attr, belongsTo, hasMany } from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import type UserModel from './user';
import type CompanyModel from './company';
import type StocktakingEntryModel from './stocktaking-entry';

export default class StocktakingModel extends Model {
  declare [Type]: 'stocktaking';
  @attr()
  declare notes?: string;
  @attr
  declare status: string; // created, done, canceled

  @belongsTo('company', { async: false, inverse: null })
  declare company: CompanyModel;
  @hasMany('stocktaking-entry', { async: false, inverse: 'stocktaking' })
  declare stocktakingEntries: StocktakingEntryModel[];

  // @attr('date')
  // declare created_at: Date;
  @attr()
  declare created_at: string;
  @attr('date')
  declare updated_at: Date;

  @belongsTo('user', { async: false, inverse: null })
  declare created_by: UserModel;
  @belongsTo('user', { async: false, inverse: null })
  declare updated_by: UserModel;
}
